export const LOCKED_BYPASS_MODE_ACTOR_TYPES = ['DeployKey']
